import React from "react";
import { useRouteContext } from "@providers/RouteProvider";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Breadcrumb from "@components/Breadcrumbs";
import Banner from "@components/Banner";
import General from "@components/Article/General";
import Detail from "@components/Article/Detail";
import SectionShare from "@components/Article/SectionShare";
import SectionArticle from "@components/Article/SectionArticle";
import ClientWrapper from "@containers/ClientWrapper";
import getter from "@services/StoryArticleService/getter";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";

const View = ({}: any) => {
  const { article, hotel } = usePageContext();
  const { router } = useRouteContext();
  const slug = _.get(router, "query.slug", "");
  const { scroll } = useLocomotiveContext();
  React.useEffect(() => {
    if (scroll) scroll.scrollTo("top", { duration: 0.2 });
  }, [slug]);
  return (
    <div className="articlePage" data-scroll-container>
      <Header />
      <Banner overlay={false} image={getter.image(article)} />
      <Breadcrumb
        data={router.breadcrumbs("storiesArticle", {
          hotel,
          title: (
            <span className="w-40 text-ellipsis-1">
              {getter.title(article)}
            </span>
          ),
        })}
      />
      <General />
      <Detail />
      <ClientWrapper>
        <SectionShare light={true} />
      </ClientWrapper>
      <SectionArticle light />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
